import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { color } from '../../../app/theme';
import IconAddCircle from '../../../assets/images/Icons/IconAddCircle';
import icMinusCircle from '../../../assets/images/svg/ic-minus-circle.svg';
import { setNodeData } from '../../../features/mainSlice';
import TagCondition from '../../shared/TagCondition';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 36,
    },
    title: {
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 15,
      lineHeight: '15px',
      color: color.$3,
      marginBottom: 12,
    },
    deleteIcon: {
      cursor: 'pointer',
      marginTop: 8,
      marginLeft: 8,
    },
    icon: {
      display: 'inline-flex',
      alignItems: 'center',
      color: color.$2,
      fontSize: 15,
      lineHeight: 1,
      cursor: 'pointer',
      marginBottom: 12,
      '&:hover': {
        opacity: '0.6',
      },
      '& > svg': {
        marginRight: 4,
      },
    },
    row: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: 12,
    },
  },
  {
    name: 'Tag',
  },
);

const Tag = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { selectedNode } = useSelector(state => state.ma);
  const { triggerCondition } = selectedNode?.data;

  const handleChangeValue = (dtag, idx) => {
    dispatch(
      setNodeData({
        triggerCondition: triggerCondition.map((d, i) => {
          if (i === idx) {
            return dtag;
          }

          return d;
        }),
      }),
    );
  };

  const removeKeyCondition = idx => {
    dispatch(
      setNodeData({
        triggerCondition: triggerCondition.filter((d, i) => i !== idx),
      }),
    );
  };

  const onAddSubFilter = () => {
    dispatch(
      setNodeData({
        triggerCondition: [...triggerCondition, {}],
      }),
    );
  };

  return (
    <div className={classes.root}>
      <div className={classes.title}>{t('condition-setting.clickType')}</div>
      {triggerCondition.map((d, i) => (
        <div className={classes.row} key={`${selectedNode?.id}-${i}`}>
          <TagCondition
            condition={{ value: d }}
            onAddConditionValue={tag => handleChangeValue(tag, i)}
            disabledDate
          />
          {triggerCondition.length > 1 && (
            <div className={classes.deleteIcon}>
              <img
                src={icMinusCircle}
                alt="minus"
                onClick={() => removeKeyCondition(i)}
              />
            </div>
          )}
        </div>
      ))}
      <div className={classes.icon} onClick={onAddSubFilter}>
        <IconAddCircle id="icon-add-message-type" width={20} height={20} />
        {t(`tagCondition.add-to-narrow-down`)}
      </div>
    </div>
  );
};

export default Tag;
